import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useModuleSettings } from '../../../components/moduleSettingsContext/ModuleSettingsContext';
import { language } from '../../../slices/languageSlice';
import { course } from '../../../slices/courseSlice';
import Loader from '../../../components/loader';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { encrypt } from '../../../common/enc_dec';
import userIcon from "../../../assets/avatar.png";

const TrainingReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { courseList } = useSelector((state) => state.course);
  const { search, setSearch, page, setPage, limit, setLimit, lang, setLang, resetSettings } = useModuleSettings();
  const { languageList } = useSelector((state) => state.language);

  useEffect(() => {
    dispatch(language({ limit: 10 }))
  }, [dispatch])

  useEffect(() => {
    dispatch(course({
      search, page, limit, language: lang
    }))
  }, [dispatch, search, page, limit, lang]);

  const handleLanguageChange = (event) => {
    const newLanguage = event.target.value;
    setLang(newLanguage);
  };

  const handleSearchChange = (event) => {
    const newSearch = event.target.value;
    setSearch(newSearch);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    // setLocalStorageItem("page", newPage);
  };

  const handleRowsPerPageChange = (newLimit) => {
    setLimit(newLimit);
    // setLocalStorageItem("limit", newLimit);
  };

  const handleView = (row) => {
    resetSettings();
    navigate(`/training-report/view?id=${encrypt(`${row.id}`)}`, { state: { id: row.id } });
  };

  const columns = [
    {
      name: "Sr No",
      selector: (row, index) => (page - 1) * limit + index + 1,
      sortable: false,
      minWidth: "80px",
      style: {
        fontSize: "14px",
      },
    },
    {
      name: "Course Id",
      selector: (row, index) => row.id,
      sortable: true,
      minWidth: "150px",
      style: {
        fontSize: "14px",
      },
    },
    {
      name: "Image",
      selector: (row) =>
        row.image ? (
          <img src={row.image} alt="trainer image" style={{ height: "6vh", padding: "5px" }} />
        ) : (
          <img src={userIcon} alt="trainer image" style={{ height: "6vh", padding: "5px" }} />
        ),
      minWidth: "150px",
      style: {
        fontSize: "14px",
      },
    },
    {
      name: "Name",
      selector: (row, index) => row.name,
      sortable: true,
      minWidth: "250px",
      maxWidth: "400px",
      class: "text-truncate",
      style: {
        fontSize: "14px",
      },
    },
    {
      name: "Language",
      selector: (row) => row.language,
      sortable: true,
      minWidth: "150px",
      style: {
        fontSize: "14px",
      },
    },
    {
      name: "Duration",
      selector: (row) => row.duration,
      cell: (row) => {
        const duration = moment.duration(row.duration, 'milliseconds');
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        return `${hours}h ${minutes}m`;
      },
      sortable: true,
      minWidth: "150px",
      grow: 2,
      style: {
        fontSize: "14px",
      },
    },
    {
      name: "Price",
      selector: (row) => row.price,
      cell: (row) => ('₹' + row.price),
      sortable: true,
      minWidth: "150px",
      style: {
        fontSize: "14px",
      },
    },
    {
      name: "Created at",
      selector: (row) => moment(row.createdAt).format("DD-MMM-YYYY"),
      sortable: true,
      minWidth: "150px",
      style: {
        fontSize: "14px",
      },
    },
    {
      name: "Total purchase",
      selector: (row) => (row.total_purchage),
      sortable: true,
      minWidth: "150px",
      style: {
        fontSize: "14px",
      },
    },
    {
      name: "Action",
      selector: (row) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button className="btn" onClick={() => handleView(row)}>
            <i
              className="fe-eye font-22 avatar-title text-primary"
              style={{ color: "blue" }}
            />
          </button>
        </div>
      ),
      minWidth: "250px",
      style: {
        fontSize: "14px",
        display: "flex",
        justifyContent: "center",
      },
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        justifyContent: "center",
      },
    },
    cells: {
      style: {
        justifyContent: "center",
      },
    },
  };

  if (!courseList?.data) {
    return (
      <Loader />
    )
  }

  return (
    <>
      <Helmet>
        <title>GUARDING.TECH | Course</title>
      </Helmet>

      <div className='content-page'>
        <div className="col-md-12 col-xl-12 mt-3">
          <div className={`widget-rounded-circle card`}>
            <div className="card-body">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                <div>
                  <h3 className="text-info">Course</h3>
                </div>
              </div>
              <div className="row">
                <DataTable
                  title={null}
                  columns={columns}
                  data={courseList.data}
                  pagination
                  paginationServer
                  paginationTotalRows={courseList?.paging?.total}
                  paginationDefaultPage={page}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
                  onChangeRowsPerPage={handleRowsPerPageChange}
                  onChangePage={handlePageChange}
                  responsive
                  selectableRowsHighlight
                  highlightOnHover
                  striped
                  subHeader
                  fixedHeader
                  fixedFooter
                  persistTableHead
                  subHeaderWrap
                  subHeaderAlign="left"
                  noDataComponent={<h5 className="p-3">No Data Found</h5>}
                  subHeaderComponent={
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <div>
                          <input
                            type="text"
                            value={search}
                            onChange={handleSearchChange}
                            placeholder="Search"
                            style={{ padding: "4px", borderRadius: "5px", border: "1px solid #ccc" }}
                          />
                        </div>
                        <div>
                          <select value={lang} onChange={handleLanguageChange} style={{ padding: "5px 20px" }}>
                            <option value={""}>
                              ALL
                            </option>
                            {languageList?.data?.map((langItem) => (
                              <option key={langItem.id} value={langItem.name}>
                                {langItem.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  }
                  customStyles={customStyles}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TrainingReport;